import { createRouter, createWebHistory } from 'vue-router'
import { getToken, getAdmin } from '@/utils/auth'

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue'), meta: { public: true } },
  { path: '/dingtalk-callback', component: () => import('@/views/DingtalkCallback.vue'), meta: { public: true } },
  { path: '/403', component: () => import('@/views/Forbidden.vue') },
  {
    path: '/',
    component: () => import('@/components/Layout/AppLayout.vue'),
    children: [
      // 落地页按权限动态决定：以前写死跳 /employees，只有报销单权限的用户
      // 一进来就撞 403
      { path: '', redirect: () => firstAvailablePath() },
      { path: 'employees', component: () => import('@/views/employees/EmployeeList.vue') },
      { path: 'employees/:id', component: () => import('@/views/employees/EmployeeDetail.vue') },
      { path: 'biz-accounts', component: () => import('@/views/biz-accounts/BizAccountList.vue') },
      { path: 'emails', component: () => import('@/views/emails/EmailManagement.vue') },
      { path: 'settings/companies', component: () => import('@/views/settings/CompanyList.vue') },
      { path: 'settings/dingtalk', component: () => import('@/views/settings/DingtalkConfig.vue') },
      { path: 'settings/biz-systems', component: () => import('@/views/settings/BizSystemList.vue') },
      { path: 'settings/exmail', component: () => import('@/views/settings/ExmailConfig.vue') },
      { path: 'settings/admins', component: () => import('@/views/settings/AdminList.vue') },
      { path: 'settings/roles', component: () => import('@/views/settings/RoleList.vue') },
      { path: 'logs/sync', component: () => import('@/views/logs/SyncLogs.vue') },
      { path: 'logs/operation', component: () => import('@/views/logs/OperationLogs.vue') },
      { path: 'logs/audit', component: () => import('@/views/logs/AuditLogs.vue') },
      { path: 'dingtalk/attendance', component: () => import('@/views/dingtalk/AttendanceExport.vue') },
      { path: 'purchase', component: () => import('@/views/purchase/PurchaseList.vue') },
      { path: 'expense-reports', component: () => import('@/views/expense/ExpenseReportList.vue') },
      { path: 'expense-management', component: () => import('@/views/expense/ExpenseManagement.vue') },
      { path: 'expense-reports/new', component: () => import('@/views/expense/ExpenseReportForm.vue') },
      { path: 'expense-reports/:id', component: () => import('@/views/expense/ExpenseReportForm.vue') }
    ]
  }
]

/** 把后端返回的菜单树摊平成 [{path, code}] */
function flatMenus() {
  const admin = getAdmin()
  const out = []
  const walk = (items) => {
    (items || []).forEach(m => {
      if (m.path) out.push({ path: m.path, code: m.code })
      if (m.children) walk(m.children)
    })
  }
  walk(admin && admin.menus)
  return out
}

/** 当前账号有权限的第一个页面，没有就退回报销单 */
function firstAvailablePath() {
  const flat = flatMenus()
  return flat.length ? flat[0].path : '/expense-reports'
}

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!getToken()) return next('/login')
  if (to.path === '/403') return next()

  // 后端才是权限边界（每个端点都挂了 require_resource），这里只是提前拦一下，
  // 免得用户手敲一个没权限的地址进去看到一整页 403 报错弹窗
  const admin = getAdmin()
  if (admin && Array.isArray(admin.menus)) {
    const allowed = flatMenus().map(m => m.path)
    // 详情页这类带参数的子路由按前缀匹配（如 /employees/12 归到 /employees）
    const permitted = allowed.some(p => to.path === p || to.path.startsWith(p + '/'))
    if (!permitted && to.path !== '/') return next('/403')
  }
  next()
})

export default router
